<template>
  <div>
    <div class="popup-info__area section">
      <div class="label">
        {{ $t("labels.influence") }}
      </div>

      <div>
        <i18n-t keypath="texts.updateOnChange" tag="div" scope="global">
          <strong>{{ $t("texts.updateOnChangeBold") }}</strong>
          <span>{{ ctx.startItem?.title }}</span>
        </i18n-t>
        {{ $t("labels.maxInfluence") }}{{ $t(":") }}
        {{ maxInfluence }}
      </div>
    </div>

    <div
      class="popup-info__area section"
    >
      <div class="label">
        {{
          $t("labels.updateXWhenYChanges", [
            ctx.endItem?.title,
            ctx.startItem?.title
          ])
        }}
      </div>
      <input-curve
        style="width: 20rem"
        :value="startItemValue"
        :x-min="startItemMinMax.minValue"
        :x-max="startItemMinMax.maxValue"
        :point-list="ctx.relation.curvePoints"
        :type="ctx.relation.curveType"
        :type-editable="false"
        :curve-editable="false"
        :formula="ctx.relation.formula"
        @hovervalue="updateChangeCurveHover($event)"
      />
      <p>
        {{
          $t("texts.resourceInfluenceExampleImpulse", {
            element: ctx.startItem?.title,
            startUnit: startItemUnit ? ` ${startItemUnit}` : "",
            resource: ctx.endItem?.title,
            endUnit: ctx.endItem?.unit ? ` ${ctx.endItem.unit}` : "",
            startValueA: changeCurveHover.x2,
            startValueB: changeCurveHover.x,
            impulseValue: changeCurveHover.y - changeCurveHover.y2
          })
        }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, computed } from "vue";

import InputCurve from "@editor/items/relation/InputCurve.vue";

import { useRelation } from "./useRelation";
import { useSimulationViewStore } from "@editor/views/simulation/simulationView.store";

import type { SimulationRoundItem } from "../simulationRound/SimulationRoundItem";
import type { RelationItem } from "./RelationItem";

const props = withDefaults(
  defineProps<{
    item: RelationItem;
    round: SimulationRoundItem | null;
  }>(),
  {
    round: null
  }
);

const ctx = useRelation(() => props.item.id);

const maxInfluence = computed(() => {
  if (ctx.graphModel == null) return 0;
  return ctx.graphModel.absoluteMaxInfluence;
});

const startItemValue = computed((): number => {
  if (ctx.startItem == null) return 0;

  const simulationViewStore = useSimulationViewStore();
  const uid = `${ctx.startItem.type}_${ctx.startItem.id}`;

  return Number(simulationViewStore.elementValues[uid].value ?? 0);
});
const startItemMinMax = computed(() => {
  if (ctx.startItem == null) return { minValue: 0, maxValue: 10 };

  const uid = `${ctx.startItem.type}_${ctx.startItem.id}`;

  const simulationViewStore = useSimulationViewStore();
  return simulationViewStore.elementValues[uid];
});
const startItemUnit = computed(() => {
  if (ctx.startItem == null) return "";
  if ("unit" in ctx.startItem) return ctx.startItem.unit;

  return "";
});

// ============================
// Curve hover values

const changeCurveHover = reactive({
  x: 0,
  y: 0,
  x2: 0,
  y2: 0
});
function updateChangeCurveHover(newData: {
  x: number;
  y: number;
  x2: number;
  y2: number;
}) {
  changeCurveHover.x = newData.x;
  changeCurveHover.y = newData.y;
  changeCurveHover.x2 = newData.x2;
  changeCurveHover.y2 = newData.y2;
}
</script>
